/* global cordova */
import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { GoogleMap, Marker, useLoadScript } from "@react-google-maps/api";
import "./check.css";
import myorders from "../component/img/myorders.jpg";
import DeliveryTimer from "../DeliveryTimer"; // adjust path accordingly

const mapContainerStyle = { width: "100%", height: "400px" };
const defaultCenter = { lat: 26.9124, lng: 75.7873 };

const Checkoutdata = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [fetchingLocation, setFetchingLocation] = useState(false);
  const [timeLeft, setTimeLeft] = useState(null);
  const [timerVisible, setTimerVisible] = useState(false);
  const [locationError, setLocationError] = useState("");
  const { finaltotal = 0, userEmail = "" } = location.state || {};

  const { isLoaded } = useLoadScript({
    googleMapsApiKey:
      process.env.REACT_APP_GOOGLE_MAPS_API_KEY ||
      "AIzaSyCCyX0p7CT8yKWdAJFeEFsutCGON58bajw",
  });

  const numericFinalTotal = Number(finaltotal) || 0;
  const computedDeliveryCharge = numericFinalTotal >= 200 ? 0 : 5;

  const computedFinalTotal = numericFinalTotal + computedDeliveryCharge;

  const [formData, setFormData] = useState({
    name: "",
    number: userEmail,
    address: "",
    city: "",
    state: "",
    paymethod: "cod",
  });

  const [locationCoords, setLocationCoords] = useState(null);
  const [originalData, setOriginalData] = useState({});
  const [showMapPopup, setShowMapPopup] = useState(false);
  const [renderMap, setRenderMap] = useState(false);
  const [loading, setLoading] = useState(false);
  const [orderMessage, setOrderMessage] = useState("");
  const [error, setError] = useState("");
  const [hasChanged, setHasChanged] = useState(false);
  const [cordovaReady, setCordovaReady] = useState(false);

  useEffect(() => {
    if (userEmail) fetchUserData();
  }, [userEmail]);

  useEffect(() => {
    if (showMapPopup) {
      const timeout = setTimeout(() => setRenderMap(true), 100);
      return () => clearTimeout(timeout);
    } else {
      setRenderMap(false);
    }
  }, [showMapPopup]);
  {
    /* for store time*/
  }

  useEffect(() => {
    if (!userEmail) return;

    const expiry = localStorage.getItem(`deliveryTimerExpiresAt_${userEmail}`);
    if (expiry) {
      const expiresAt = parseInt(expiry, 10);
      const diff = Math.floor((expiresAt - Date.now()) / 1000);
      if (diff > 0) {
        setTimeLeft(diff);
        setTimerVisible(true);
      } else {
        localStorage.removeItem(`deliveryTimerExpiresAt_${userEmail}`);
      }
    }
  }, [userEmail]);

  //tracking script
  window.gtag("event", "checkout_visited ", {
    screen_name: "checkout screen visited",
    phone: userEmail,
  });

  const fetchUserData = async () => {
    // setLoading(true);
    try {
      const { data } = await axios.get(
        "https://yaasaai.com/myphpapi/getuserinfo.php",
        {
          params: { phoneNumber: userEmail },
        }
      );
      if (data && !data.error) {
        const userData = {
          name: data.name || "",
          number: data.phonenumber || userEmail,
          address: data.address || "",
          city: "Tonk",
          state: "Rajasthan",
          paymethod: "cod",
        };
        setFormData(userData);
        setOriginalData(userData);
      } else {
        throw new Error(data.error || "User data fetch failed.");
      }
    } catch {
      setError("Error fetching user details.");
    } finally {
      setLoading(false);
    }
  };

  const updateUserData = async () => {
    if (!hasChanged) return true;
    try {
      await axios.post(
        "https://yaasaai.com/myphpapi/updateuserinfo.php",
        {
          ...formData,
          phonenumber: formData.number,
        },
        {
          headers: { "Content-Type": "application/json" },
        }
      );
      return true;
    } catch {
      setError("Failed to update user info.");
      return false;
    }
  };

  const updateLocationData = async () => {
    if (!locationCoords) return true;
    try {
      await axios.post(
        "https://yaasaai.com/myphpapi/update-user-location-info.php",
        {
          ...formData,
          phonenumber: userEmail,
          lat: locationCoords.lat,
          lng: locationCoords.lng,
        },
        {
          headers: { "Content-Type": "application/json" },
        }
      );
      return true;
    } catch (err) {
      setError("Failed to update user location.");
      return false;
    }
  };

  const validateInputs = () => {
    if (!formData.name.trim()) return setError("Name is required"), false;
    if (!/^\d{10}$/.test(formData.number))
      return setError("Invalid phone number"), false;
    if (
      !formData.address.trim() ||
      !formData.city.trim() ||
      !formData.state.trim()
    ) {
      return setError("Complete address required"), false;
    }
    setError("");
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateInputs()) return;
    if (computedFinalTotal < 100) {
      alert("Minimum order amount is Rs. 100. Please add more items.");
      return; // stop checkout
    }
    //setLoading(true);
    const updated = await updateUserData();
    const locationSaved = await updateLocationData();
    if (updated) await handleCheckout();
    setLoading(false);
  };

  const handleCheckout = async () => {
    try {
      const { data } = await axios.post(
        "https://yaasaai.com/myphpapi/checkout.php",
        {
          phoneNumber: formData.number,
        },
        {
          headers: { "Content-Type": "application/json" },
        }
      );

      if (data?.message) {
        setOrderMessage("Order placed! Delivery in 30 minutes.");
        setTimeLeft(30 * 60); // 30 minutes in seconds
        setTimerVisible(true); // Show timer on screen
        // const expiryTime = Date.now() + 30 * 60 * 1000; // current time + 30 minutes
        // Example - setting timer for 30 seconds from now
        localStorage.setItem(
          `deliveryTimerExpiresAt_${userEmail}`,
          (Date.now() + 30 * 60 * 1000).toString()
        );

        // ✅ GA4 Event: order_placed
        if (typeof window.gtag === "function") {
          window.gtag("event", "order_placed", {
            user_id: formData.number,
            status: "success",
            message: data.message,
            timestamp: new Date().toISOString(),
          });
        }
        // navigate after 5 minutes
        setTimeout(() => navigate("/"), 5000);
      } else {
        throw new Error(data?.error || "Checkout failed.");
      }
    } catch {
      setError("Failed to process order.");
    }
  };

  useEffect(() => {
    document.addEventListener("deviceready", onDeviceReady, false);

    function onDeviceReady() {
      console.log("Cordova is ready");
      // Optionally set a state to enable button
    }

    return () => {
      document.removeEventListener("deviceready", onDeviceReady);
    };
  }, []);

  const getUserLocation = () => {
    if (
      window.cordova &&
      cordova.plugins &&
      cordova.plugins.permissions &&
      cordova.plugins.diagnostic
    ) {
      const permissions = cordova.plugins.permissions;
      const diagnostic = cordova.plugins.diagnostic;

      diagnostic.isLocationEnabled(
        (enabled) => {
          if (!enabled) {
            alert(
              "Location services are disabled on your device. Please enable GPS/location services to continue."
            );
            return;
          }

          if (!navigator.geolocation) {
            alert("Geolocation is not supported or not available.");
            return;
          }

          permissions.checkPermission(
            permissions.ACCESS_FINE_LOCATION,
            (status) => {
              if (status.hasPermission) {
                navigator.geolocation.getCurrentPosition(
                  (pos) => {
                    setLocationCoords({
                      lat: pos.coords.latitude,
                      lng: pos.coords.longitude,
                    });
                    setShowMapPopup(true);
                  },
                  (error) => {
                    console.error("Error getting location:", error);
                    if (error.code === error.PERMISSION_DENIED) {
                      alert(
                        "Location permission denied. Please enable location services."
                      );
                    } else if (error.code === error.POSITION_UNAVAILABLE) {
                      alert(
                        "Location unavailable. Please make sure GPS/location is enabled."
                      );
                    } else if (error.code === error.TIMEOUT) {
                      alert(
                        "Location unavailable. Please make sure GPS/location is enabled."
                      );
                    } else {
                      alert("Failed to get location: " + error.message);
                    }
                  },
                  {
                    timeout: 10000,
                    enableHighAccuracy: true,
                    maximumAge: 0,
                  }
                );
              } else {
                permissions.requestPermission(
                  permissions.ACCESS_FINE_LOCATION,
                  (res) => {
                    if (res.hasPermission) {
                      navigator.geolocation.getCurrentPosition(
                        (pos) => {
                          setLocationCoords({
                            lat: pos.coords.latitude,
                            lng: pos.coords.longitude,
                          });
                          setShowMapPopup(true);
                        },
                        (error) => {
                          console.error(
                            "Error getting location after permission:",
                            error
                          );
                          alert(
                            "Location access denied or turned off. Please enable location services."
                          );
                        },
                        {
                          timeout: 10000,
                          enableHighAccuracy: true,
                          maximumAge: 0,
                        }
                      );
                    } else {
                      alert(
                        "Location permission denied. Please enable location services."
                      );
                    }
                  },
                  () => {
                    alert("Permission request failed.");
                  }
                );
              }
            }
          );
        },
        (error) => {
          alert("Error checking location services: " + error);
        }
      );
    } else if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          setLocationCoords({
            lat: pos.coords.latitude,
            lng: pos.coords.longitude,
          });
          setShowMapPopup(true);
        },
        (error) => {
          console.error("Error getting location (web):", error);
          if (error.code === error.PERMISSION_DENIED) {
            alert(
              "Location permission denied. Please enable location services."
            );
          } else if (error.code === error.POSITION_UNAVAILABLE) {
            alert(
              "Location unavailable. Please make sure GPS/location is enabled."
            );
          } else if (error.code === error.TIMEOUT) {
            alert(
              "Location unavailable. Please make sure GPS/location is enabled."
            );
          } else {
            alert("Failed to get location: " + error.message);
          }
        },
        {
          timeout: 5000,
          enableHighAccuracy: true,
          maximumAge: 0,
        }
      );
    } else {
      alert("Geolocation is not supported by your browser.");
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (value !== formData[name]) setHasChanged(true);
    setFormData({ ...formData, [name]: value });
  };

  const handleMapClick = (e) => {
    setLocationCoords({ lat: e.latLng.lat(), lng: e.latLng.lng() });
  };

  const renderMapPopup = () =>
    showMapPopup && (
      <div className="popup-overlay">
        <div className="popup-content">
          <h3>Select Your Delivery Location</h3>
          {isLoaded && renderMap ? (
            <GoogleMap
              mapContainerStyle={mapContainerStyle}
              zoom={15}
              center={locationCoords || defaultCenter}
              onClick={handleMapClick}
            >
              {locationCoords && (
                <Marker
                  position={locationCoords}
                  draggable
                  onDragEnd={(e) =>
                    setLocationCoords({
                      lat: e.latLng.lat(),
                      lng: e.latLng.lng(),
                    })
                  }
                />
              )}
            </GoogleMap>
          ) : (
            <div style={{ textAlign: "center", padding: "20px" }}>
              <div className="spinner" />
              <p style={{ marginTop: "10px" }}>Loading map, please wait...</p>
            </div>
          )}

          <div className="popup-actions">
            <button onClick={() => setShowMapPopup(false)}>Cancel</button>
            <button
              type="button"
              onClick={async () => {
                const success = await updateLocationData();
                if (success) {
                  const updatedAddress = `Lat: ${locationCoords?.lat}, Lng: ${locationCoords?.lng}`;
                  setFormData((prev) => ({ ...prev }));
                  setHasChanged(true);
                  setShowMapPopup(false);
                  // alert("Location updated successfully");
                }
              }}
            >
              Confirm Location
            </button>
          </div>
        </div>
      </div>
    );

  return (
    <div
      style={{
        backgroundImage: `url(${myorders})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <div className="checkout-container">
        {loading ? (
          <p>Processing request...</p>
        ) : orderMessage ? (
          <div className="order-message">
            <h3>{orderMessage}</h3>
            <p>Redirecting to home page in 5 seconds...</p>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="checkout-form">
            {renderMapPopup()}
            <div className="form-center">
              <div className="form-left">
                <h4>Fill Delivery Details</h4>
                {["name", "number", "address"].map((field) => (
                  <div className="form-group" key={field}>
                    <label>{`Enter Your ${
                      field.charAt(0).toUpperCase() + field.slice(1)
                    }`}</label>
                    <input
                      type="text"
                      name={field}
                      value={formData[field]}
                      onChange={handleInputChange}
                      placeholder={`Enter Your ${field}`}
                      required
                    />
                  </div>
                ))}

                {/* Fixed city field */}
                <div className="form-group">
                  <label>City</label>
                  <input type="text" name="city" value="Tonk" readOnly />
                </div>

                {/* Fixed state field */}
                <div className="form-group">
                  <label>State</label>
                  <input type="text" name="state" value="Rajasthan" readOnly />
                </div>

                <div className="form-group">
                  <button
                    type="button"
                    onClick={getUserLocation}
                    className="btn btn-secondary"
                    disabled={showMapPopup}
                  >
                    {fetchingLocation
                      ? "Fetching location..."
                      : showMapPopup
                      ? "Loading map..."
                      : "Use My Location"}
                  </button>

                  {locationCoords && (
                    <p>
                      Location set: Lat {locationCoords.lat.toFixed(4)}, Lng{" "}
                      {locationCoords.lng.toFixed(4)}
                    </p>
                  )}
                </div>
                {error && <p className="error-msg">{error}</p>}
              </div>

              <div className="form-right">
                <div className="price-details">
                  <h3>Price Details</h3>
                  <div className="price-item">
                    <strong>Total Price :</strong>
                    <span>Rs. {numericFinalTotal.toFixed(2)}</span>
                  </div>
                  <div className="price-item">
                    <strong>Delivery Charge :</strong>
                    <span>Rs. {computedDeliveryCharge.toFixed(2)}</span>
                  </div>
                  <div className="price-item">
                    <strong>Final Total Price :</strong>
                    <span>Rs. {computedFinalTotal.toFixed(2)}</span>
                  </div>

                  {/* offer code section 
                  <div className="offer-code">
                    <label>Have an Offer Code?</label>
                    <input type="text" placeholder="Enter offer code" />
                    <button type="button" className="btn btn-success">
                      Apply
                    </button>
                  </div>
                  */}
                  <div className="payment-method">
                    <strong>Payment Method</strong>
                    <div className="radio-group">
                      <input
                        type="radio"
                        name="paymethod"
                        value="cod"
                        checked={formData.paymethod === "cod"}
                        onChange={handleInputChange}
                      />
                      Cash on Delivery
                    </div>
                  </div>
                </div>
              </div>
              <button type="submit" className="btn btn-primary">
                Proceed to Checkout
              </button>
            </div>
          </form>
        )}

        {/*  {timerVisible && (
          <div
            style={{
              position: "fixed",
              bottom: 0,
              left: 0,
              width: "100%",
              backgroundColor: "#000000cc",
              color: "white",
              padding: "10px",
              textAlign: "center",
              fontSize: "16px",
              zIndex: 1000,
            }}
          >
            ⏳ Estimated Delivery Time Left: {Math.floor(timeLeft / 60)}:
            {String(timeLeft % 60).padStart(2, "0")}
          </div>
        )}
        {timerVisible && <DeliveryTimer visibleOnly={true} />} */}
      </div>
    </div>
  );
};

export default Checkoutdata;
